export default [
  // new teachers:
  {
    id: '1',
    firstName: 'Abigail',
    lastName: 'Smith',
    name: 'Abigail Smith',
    email: 'abigail.smith@domain.com',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'TEACHER',
    schoolRoles: 'teacher,teacher',
    hasBeenReviewed: false,
  },
  {
    id: '2',
    firstName: 'Benjamin',
    lastName: 'Johnson',
    name: 'Benjamin Johnson',
    email: 'benjamin.johnson@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles:
      'APS - PA to Headmaster and EA to Leadership Team, APS - Volunteer Pre-prep Parent Helper, APS - PA to',
    hasBeenReviewed: true,
  },
  {
    id: '3',
    firstName: 'Catherine',
    lastName: 'Williams',
    name: 'Catherine Williams',
    email: 'catherine.williams@domain.com',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '4',
    firstName: 'Daniel',
    lastName: 'Brown',
    name: 'Daniel Brown',
    email: 'daniel.brown@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '5',
    firstName: 'Emily',
    lastName: 'Jones',
    name: 'Emily Jones',
    email: 'emily.jones@domain.com',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '6',
    firstName: 'Finn',
    lastName: 'Martinez',
    name: 'Finn Martinez',
    email: 'finn.martinez@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '7',
    firstName: 'Grace',
    lastName: 'Taylor',
    name: 'Grace Taylor',
    email: 'grace.taylor@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '8',
    firstName: 'Henry',
    lastName: 'Anderson',
    name: 'Henry Anderson',
    email: 'henry.anderson@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '9',
    firstName: 'Isabella',
    lastName: 'White',
    name: 'Isabella White',
    email: 'isabella.white@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '10',
    firstName: 'Jacob',
    lastName: 'Hernandez',
    name: 'Jacob Hernandez',
    email: 'jacob.hernandez@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '11',
    firstName: 'Katherine',
    lastName: 'Lee',
    name: 'Katherine Lee',
    email: 'katherine.lee@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '12',
    firstName: 'Liam',
    lastName: 'Clark',
    name: 'Liam Clark',
    email: 'liam.clark@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '13',
    firstName: 'Mia',
    lastName: 'Lewis',
    name: 'Mia Lewis',
    email: 'mia.lewis@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '14',
    firstName: 'Noah',
    lastName: 'Walker',
    name: 'Noah Walker',
    email: 'noah.walker@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '15',
    firstName: 'Olivia',
    lastName: 'Hall',
    name: 'Olivia Hall',
    email: 'olivia.hall@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '16',
    firstName: 'Peter',
    lastName: 'Wright',
    name: 'Peter Wright',
    email: 'peter.wright@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '17',
    firstName: 'Quinn',
    lastName: 'Lopez',
    name: 'Quinn Lopez',
    email: 'quinn.lopez@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '18',
    firstName: 'Rachel',
    lastName: 'Young',
    name: 'Rachel Young',
    email: 'rachel.young@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '19',
    firstName: 'Samuel',
    lastName: 'Adams',
    name: 'Samuel Adams',
    email: 'samuel.adams@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '20',
    firstName: 'Thomas',
    lastName: 'Gonzalez',
    name: 'Thomas Gonzalez',
    email: 'thomas.gonzalez@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '21',
    firstName: 'Ursula',
    lastName: 'Rodriguez',
    name: 'Ursula Rodriguez',
    email: 'ursula.rodriguez@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '22',
    firstName: 'Victor',
    lastName: 'Scott',
    name: 'Victor Scott',
    email: 'victor.scott@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '23',
    firstName: 'Wendy',
    lastName: 'Perez',
    name: 'Wendy Perez',
    email: 'wendy.perez@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: null,
    hasBeenReviewed: true,
  },
  {
    id: '24',
    firstName: 'Xavier',
    lastName: 'Miller',
    name: 'Xavier Miller',
    email: 'xavier.miller@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles:
      'ICT, IS Development, Sports Coach - Kayaking, Volunteer - Sailing',
    hasBeenReviewed: true,
  },
  {
    id: '25',
    firstName: 'Yvonne',
    lastName: 'Cook',
    name: 'Yvonne Cook',
    email: 'yvonne.cook@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '26',
    firstName: 'Zachary',
    lastName: 'Robinson',
    name: 'Zachary Robinson',
    email: 'zachary.robinson@domain.com',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '27',
    firstName: 'Greg',
    lastName: 'Greendale',
    name: 'Greg Greendale',
    email: 'g.greendale@showbie.com',
    purchaserId: '10002',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '28',
    firstName: 'Harry',
    lastName: 'Potter',
    name: 'Harry Potter',
    email: 'h.potter@domain.com',
    purchaserId: '10011',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  {
    id: '29',
    firstName: 'Harvey',
    lastName: 'Potter',
    name: 'Harvey Potter',
    email: 'h.potter@domain.com',
    purchaserId: '10011',
    action: 'DO_NOT_SYNC',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    hasBeenReviewed: true,
  },
  // new students:
  {
    id: '100',
    firstName: 'Albert',
    lastName: 'Andrews',
    name: 'Albert Andrews',
    email: 'albert.andrews@domain.com',
    username: '',
    yearGroup: '11',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    userType: 'STUDENT',
    hasBeenReviewed: false,
  },
  {
    id: '101',
    firstName: 'Barry',
    lastName: 'Bartholomew',
    name: 'Barry Bartholomew',
    email: 'barry.bartholomew@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '102',
    firstName: 'Cameron',
    lastName: 'Carter',
    name: 'Cameron Carter',
    email: 'cameron.carter@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '103',
    firstName: 'Daniel',
    lastName: 'Dawson',
    name: 'Daniel Dawson',
    email: 'daniel.dawson@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '104',
    firstName: 'Edward',
    lastName: 'Ellis',
    name: 'Edward Ellis',
    email: 'edward.ellis@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '105',
    firstName: 'Frank',
    lastName: 'Fisher',
    name: 'Frank Fisher',
    email: 'frank.fisher@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '106',
    firstName: 'George',
    lastName: 'Grant',
    name: 'George Grant',
    email: 'george.grant@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '107',
    firstName: 'Henry',
    lastName: 'Harris',
    name: 'Henry Harris',
    email: 'henry.harris@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '108',
    firstName: 'Isaac',
    lastName: 'Ingram',
    name: 'Isaac Ingram',
    email: 'isaac.ingram@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '109',
    firstName: 'Jack',
    lastName: 'Jackson',
    name: 'Jack Jackson',
    email: 'jack.jackson@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '110',
    firstName: 'Kevin',
    lastName: 'Keller',
    name: 'Kevin Keller',
    email: 'kevin.keller@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '111',
    firstName: 'Liam',
    lastName: 'Lawson',
    name: 'Liam Lawson',
    email: 'liam.lawson@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '112',
    firstName: 'Michael',
    lastName: 'Morrison',
    name: 'Michael Morrison',
    email: 'michael.morrison@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '113',
    firstName: 'Nathan',
    lastName: 'Nelson',
    name: 'Nathan Nelson',
    email: 'nathan.nelson@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '114',
    firstName: 'Oscar',
    lastName: 'Owens',
    name: 'Oscar Owens',
    email: 'oscar.owens@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '115',
    firstName: 'Paul',
    lastName: 'Patterson',
    name: 'Paul Patterson',
    email: 'paul.patterson@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '116',
    firstName: 'Quentin',
    lastName: 'Quinn',
    name: 'Quentin Quinn',
    email: 'quentin.quinn@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '117',
    firstName: 'Richard',
    lastName: 'Reynolds',
    name: 'Richard Reynolds',
    email: 'richard.reynolds@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '118',
    firstName: 'Samuel',
    lastName: 'Stewart',
    name: 'Samuel Stewart',
    email: 'samuel.stewart@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '119',
    firstName: 'Thomas',
    lastName: 'Thompson',
    name: 'Thomas Thompson',
    email: 'thomas.thompson@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '120',
    firstName: 'Ulysses',
    lastName: 'Underwood',
    name: 'Ulysses Underwood',
    email: 'ulysses.underwood@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '121',
    firstName: 'Victor',
    lastName: 'Vance',
    name: 'Victor Vance',
    email: 'victor.vance@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '122',
    firstName: 'William',
    lastName: 'Wright',
    name: 'William Wright',
    email: 'william.wright@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '123',
    firstName: 'Xavier',
    lastName: 'Xanders',
    name: 'Xavier Xanders',
    email: 'xavier.xanders@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '124',
    firstName: 'Yusuf',
    lastName: 'Young',
    name: 'Yusuf Young',
    email: 'yusuf.young@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  {
    id: '125',
    firstName: 'Zachary',
    lastName: 'Zimmerman',
    name: 'Zachary Zimmerman',
    email: 'zachary.zimmerman@domain.com',
    username: '',
    yearGroup: '12',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    userType: 'STUDENT',
    hasBeenReviewed: true,
  },
  // existing teachers:
  {
    id: '200',
    firstName: 'Existing',
    lastName: 'Eric',
    name: 'Existing Eric',
    email: 'existing.eric@showbie.com',
    purchaserId: '10003',
    action: 'SYNC_TO_RECORD',
    userType: 'TEACHER',
    showbieId: 'a1b2c3d4e5f6g7h8i9j0',
    hasBeenReviewed: false,
  },
  {
    id: '201',
    firstName: 'Hasaccount',
    lastName: 'Harold',
    name: 'Hasaccount Harold',
    email: 'hasaccount.harold@showbie.com',
    purchaserId: '10003',
    action: 'SYNC_TO_RECORD',
    userType: 'TEACHER',
    showbieId: 'b2c3d4e5f6g7h8i9j0k1',
    hasBeenReviewed: true,
  },
  {
    id: '202',
    firstName: 'Inshowbie',
    lastName: 'Isabel',
    name: 'Inshowbie Isabel',
    email: 'inshowbie.isabel@showbie.com',
    purchaserId: '10003',
    action: 'SYNC_TO_RECORD',
    userType: 'TEACHER',
    showbieId: 'c3d4e5f6g7h8i9j0k1l2',
    hasBeenReviewed: true,
  },
  {
    id: '203',
    firstName: 'Donny',
    lastName: 'Doyle',
    name: 'Donny Doyle',
    email: 'd.doyle@showbie.com',
    purchaserId: '12003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    showbieId: 'd4e5f6g7h8i9j0k1l2m3',
    hasBeenReviewed: true,
  },
  // existing students:
  {
    id: '204',
    firstName: 'Adam',
    lastName: 'Anunverifiedemail',
    name: 'Adam Anunverifiedemail',
    email: 'a.anunverifiedemail@showbie.com',
    emailStatus: 'UNVERIFIED',
    purchaserId: '10003',
    action: 'SYNC_TO_RECORD',
    userType: 'STUDENT',
    showbieId: 'e5f6g7h8i9j0k1l2m3n4',
    hasBeenReviewed: false,
  },
  {
    id: '205',
    firstName: 'Sam',
    lastName: 'Studentexists',
    name: 'Sam Studentexists',
    email: 's.studentexists@showbie.com',
    emailStatus: 'VERIFIED',
    purchaserId: '10003',
    action: 'SYNC_TO_RECORD',
    userType: 'STUDENT',
    showbieId: 'e5f6g7h8i9j0k1l2m3n4',
    hasBeenReviewed: true,
  },
  // errored teacher accounts:
  {
    id: '300',
    firstName: 'Troublesome',
    lastName: 'Terry',
    name: 'Troublesome Terry',
    email: 't.terry@showbie.com',
    purchaserId: '10002',
    userType: 'TEACHER',
    showbieId: 't.terry@domain.com',
    errorCode: 'SCHOOL_DOES_NOT_MATCH',
    hasBeenReviewed: true,
  },
  {
    id: '301',
    firstName: 'Errored',
    lastName: 'Eric',
    name: 'Errored Eric',
    email: 'e.eric@showbie.com',
    purchaserId: '10002',
    userType: 'STUDENT',
    showbieId: 'e.eric@domain.com',
    errorCode: 'USER_NOT_ACTIVE',
    hasBeenReviewed: true,
  },
  {
    id: '302',
    firstName: 'Cantsync',
    lastName: 'Carl',
    name: 'Cantsync Carl',
    email: 'c.carl@showbie.com',
    purchaserId: '10002',
    userType: 'TEACHER',
    showbieId: 'c.carl@domain.com',
    errorCode: 'USER_EMAIL_NOT_VERIFIED',
    hasBeenReviewed: true,
  },
  {
    id: '303',
    firstName: 'Arlene',
    lastName: 'Admin',
    name: 'Arlene Admin',
    email: 'a.admin@showbie.com',
    purchaserId: '10002',
    userType: 'ADMIN',
    showbieId: 'a.admin@domain.com',
    errorCode: 'SCHOOL_DOES_NOT_MATCH',
    hasBeenReviewed: true,
  },
  // system error accounts:
  {
    id: '400',
    firstName: 'Oliver',
    lastName: 'Ohno',
    name: 'Oliver Ohno',
    email: 'o.ohno@showbie.com',
    purchaserId: '12003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    systemErrorMessage: 'A custom error message from the service',
    hasBeenReviewed: true,
  },
  {
    id: '401',
    firstName: 'Yolanda',
    lastName: 'Yikes',
    name: 'Yolanda Yikes',
    email: 'y.yikes@showbie.com',
    purchaserId: '12003',
    action: 'CREATE_NEW_RECORD',
    userType: 'STUDENT',
    systemErrorMessage: 'Another custom error message from the service',
    hasBeenReviewed: true,
  },
  {
    id: '402',
    firstName: 'Olga',
    lastName: 'Oops',
    name: 'Olga Oops',
    email: 'o.oops@showbie.com',
    purchaserId: '12003',
    action: 'CREATE_NEW_RECORD',
    userType: 'TEACHER',
    schoolRoles: 'teacher',
    systemErrorMessage: 'A third custom error message from the service',
    hasBeenReviewed: true,
  },
];
